import { useEffect, useRef, useState } from "react";
import ChatBubble from "../chat-bubble/ChatBubble";
import styled from "styled-components";
import { Box, Button, Modal, Switch } from "@mui/material";
import Footer from "../Footer";
//@ts-ignore
import pro1 from "../imgs/profiles/1.png";
//@ts-ignore
import pro2 from "../imgs/profiles/2.png";
//@ts-ignore
import pro3 from "../imgs/profiles/3.png";
//@ts-ignore
import pro4 from "../imgs/profiles/4.png";
//@ts-ignore
import pro5 from "../imgs/profiles/5.png";
//@ts-ignore
import pro6 from "../imgs/profiles/6.png";
//@ts-ignore
import pro7 from "../imgs/profiles/7.png";
//@ts-ignore
import pro8 from "../imgs/profiles/8.png";
//@ts-ignore
import pro9 from "../imgs/profiles/9.png";
//@ts-ignore
import pro10 from "../imgs/profiles/10.png";
//@ts-ignore
import check from "../imgs/check.png";
//@ts-ignore
import chat1 from "../imgs/chat1.png";
//@ts-ignore
import chat2 from "../imgs/chat2.png";
//@ts-ignore
// import chatmo1 from "../imgs/chat1_mo.png";
//@ts-ignore
// import chatmo2 from "../imgs/chat2_mo.png";

const Chat = ({
  profileModal,
  onClickProfileModal,
}: {
  profileModal: any;
  onClickProfileModal: any;
}) => {
  const [avatar, setAvatar] = useState(false);
  const [step, setStep] = useState(0);
  const [recordMsg, setRecordMsg] = useState("");
  const [isResetList, setIsResetList] = useState(false);
  const [isDisabledBtn, setIsDisabledBtn] = useState(false);
  const messageEndRef = useRef<HTMLDivElement | null>(null);
  const [mode, setMode] = useState("");
  const [modeModal, setModeModal] = useState(true);
  const [stop, setStop] = useState(false);

  const onResetChat = () => {
    window.location.reload();
    setStep(0);
    setRecordMsg("");
    setSelectEvert("");
    setIsGoogle(false);
    setIsTrip(false);
    setIsResetList(true);
    setStop(true);
    setMode("");
    setAvatar(false);
  };

  const onStopChat = () => {
    const myAudio = document.getElementById("myAudio");
    if (myAudio) {
      //@ts-ignore
      myAudio?.pause();
      //@ts-ignore
      // myAudio?.currentTime = 0;
    }
    //@ts-ignore
  };

  const onPlayChat = () => {
    const myAudio = document.getElementById("myAudio");
    if (myAudio) {
      //@ts-ignore
      myAudio?.play();
      //@ts-ignore
      // myAudio?.currentTime = 0;
    }
    //@ts-ignore
  };

  const onChangeAvatar = () => {
    setIsDisabledBtn(true);
    setAvatar(!avatar);
  };

  const [selectEvent, setSelectEvert] = useState("");
  const [isGoogle, setIsGoogle] = useState(false);
  const [isTrip, setIsTrip] = useState(false);
  const [curProfile, setCurProfile] = useState({
    id: 1,
    img: pro1,
    title: "선생님",
    name: "vdaeseong",
  });

  const handleMode = (mode: string) => {
    setMode(mode);
    setModeModal(false);
  };

  const profileCardList = [
    {
      id: 1,
      img: pro1,
      title: "선생님",
      name: "nsinu",
    },
    {
      id: 2,
      img: pro2,
      title: "아나운서",
      name: "nes_c_mikyung",
    },
    {
      id: 3,
      img: pro3,
      title: "청소년",
      name: "njonghyun",
    },
    {
      id: 4,
      img: pro4,
      title: "여행가이드",
      name: "njiyun",
    },
    {
      id: 5,
      img: pro5,
      title: "여행가",
      name: "nes_c_sohyun",
    },
    {
      id: 6,
      img: pro6,
      title: "아이",
      name: "nwoof",
    },
    {
      id: 7,
      img: pro7,
      title: "직장인",
      name: "nyoungil",
    },
    {
      id: 8,
      img: pro8,
      title: "대학생",
      name: "nyuna",
    },
    {
      id: 9,
      img: pro9,
      title: "고등학생",
      name: "njiwon",
    },
    {
      id: 10,
      img: pro10,
      title: "점원",
      name: "nara_call",
    },
  ];

  useEffect(() => {
    messageEndRef.current?.scrollIntoView({ behavior: "smooth" });
    // if (selectEvent) {
    const detailRef = document.getElementById("detailRef");
    //@ts-ignore
    detailRef?.current.scrollIntoView({ behavior: "smooth" });
    // }
  }, [selectEvent, isGoogle, isTrip]);

  useEffect(() => {
    const storageProfile = localStorage.getItem("profile");

    if (storageProfile) {
      const foundProfile = profileCardList.find(
        (el) => el.name === storageProfile
      );

      if (foundProfile) {
        setCurProfile(foundProfile);
      }
    }
  }, []);

  const handleProfile = (el: any) => {
    setCurProfile(el);
  };

  const setProfile = () => {
    localStorage.setItem("profile", curProfile?.name);
    onClickProfileModal();
    window.location.reload();
  };

  useEffect(() => {
    if (mode === "avatar") {
      onChangeAvatar();
    }
  }, [mode]);

  return (
    <Wrapper>
      <Modal open={mode === ""} onClose={() => setModeModal(false)}>
        <Box
          sx={{
            position: "fixed",
            left: "50%",
            top: "50%",
            transform: "translate(-50%,-50%)",
            backgroundColor: "white",
            overflow: "auto",
            padding: "20px",
            width: "100%",
            height: "100%",
          }}
        >
          <ModalWrapper>
            {/* <p>채팅모드를 선택해주세요.</p> */}
            <div>
              <Button
                variant="contained"
                onClick={() => handleMode("chat")}
                color="info"
              >
                <img src={chat1} width={492} height={300} alt="" />
              </Button>
              <Button
                variant="contained"
                onClick={() => handleMode("avatar")}
                color="inherit"
              >
                <img src={chat2} width={492} height={300} alt="" />
              </Button>
            </div>
          </ModalWrapper>
        </Box>
      </Modal>
      <section>
        <div>
          <p>아바타</p>
          <Switch
            checked={avatar}
            onChange={onChangeAvatar}
            inputProps={{ "aria-label": "controlled" }}
            color="warning"
          />
        </div>
      </section>

      {profileModal && (
        <>
          <Modal open={profileModal} onClose={onClickProfileModal}>
            <Box
              sx={{
                position: "fixed",
                left: "50%",
                top: "50%",
                maxWidth: "540px",
                maxHeight: "600px",
                transform: "translate(-50%,-50%)",
                backgroundColor: "white",
                overflow: "auto",
                padding: "20px",
                width: "800px",

                "@media (max-width: 496px)": {
                  height: "100%",
                  width: "100%",
                  paddingBottom: "20px",
                  maxHeight: "100%",
                },
              }}
            >
              <ModalWrapper2>
                <CurrentProfile>
                  <div>
                    <img src={curProfile?.img} alt="" />
                    <p>{curProfile?.title}</p>
                  </div>
                </CurrentProfile>
                <Line />
                <p>변경을 원하시는 아바타를 선택해주세요.</p>
                <ProfileList>
                  {profileCardList.map((el, idx) => (
                    <AvatarCard
                      onClick={() => handleProfile(el)}
                      className={`${curProfile?.id === el?.id ? "cur" : ""}`}
                      key={idx}
                    >
                      <div>
                        {curProfile && curProfile.id === el?.id && (
                          <img
                            src={check}
                            width={24}
                            alt=""
                            className="check"
                          />
                        )}
                        <img src={el.img} alt="" className="bg" />
                        <p>{el.title}</p>
                      </div>
                    </AvatarCard>
                  ))}
                </ProfileList>
                <Button variant="contained" onClick={setProfile}>
                  아바타 설정 완료
                </Button>
              </ModalWrapper2>
            </Box>
          </Modal>
        </>
      )}

      <ChatBubble
        stop={stop}
        mode={mode}
        step={step}
        record={recordMsg}
        setRecordMsg={setRecordMsg}
        isAvatar={avatar}
        selectEvent={selectEvent}
        setSelectEvert={setSelectEvert}
        setIsGoogle={setIsGoogle}
        isGoogle={isGoogle}
        setIsTrip={setIsTrip}
        isTrip={isTrip}
        isResetList={isResetList}
        setIsResetList={setIsResetList}
        isDisabledBtn={isDisabledBtn}
      />
      <section ref={messageEndRef}></section>

      <Footer
        onResetChat={onResetChat}
        onStopChat={onStopChat}
        onPlayChat={onPlayChat}
        isAvatar={avatar}
      />
    </Wrapper>
  );
};

export default Chat;

const ProfileList = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  > div {
    margin-top: 20px;
    margin-right: 10px;
  }

  .cur {
    > div {
      > .bg {
        background-color: rgba(255, 242, 217, 1);
      }
    }
  }
`;

const ModalWrapper = styled.div`
  margin: auto;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  > p {
    color: rgba(28, 28, 28, 1);
    font-size: 12px;
    font-weight: 400;
    margin: 10px 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  > button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    color: rgba(255, 255, 255, 1);
    font-weight: 600;
    border-radius: 20px;
    padding: 10px 0;
    margin-top: 20px;
    background-color: white;
  }

  > div {
    display: flex;
    justify-content: center;

    > button {
      padding: 0;
      border-radius: 30px;
      font-size: 11px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: rgba(255, 255, 255, 1);
      font-weight: 600;
      margin-top: 20px;
      margin-right: 10px;
      background-color: white;
      border: 0;
    }

    > button:last-child {
      /* background-color: #9e9e9e; */
    }
  }

  @media (max-width: 1040px) {
    display: flex;

    > div {
      display: flex;
      flex-wrap: wrap;
    }
  }

  @media (max-width: 700px) {
    > div {
      display: flex;
      flex-direction: column;

      > button {
        border-radius: 40px;

        > img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }
`;

const ModalWrapper2 = styled.div`
  > p {
    color: rgba(28, 28, 28, 1);
    font-size: 12px;
    font-weight: 400;
    margin: 10px 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  > button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    color: rgba(255, 255, 255, 1);
    font-weight: 600;
    background-color: rgba(37, 124, 255, 1);
    border-radius: 20px;
    padding: 10px 0;
    margin-top: 20px;
  }

  > div {
    display: flex;
    justify-content: center;

    > button {
      padding: 10px 0;
      font-size: 11px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: rgba(255, 255, 255, 1);
      font-weight: 600;
      background-color: #638ed0;
      margin-top: 20px;
      margin-right: 10px;
    }

    > button:last-child {
      background-color: #9e9e9e;
    }
  }

  @media screen and (max-width: 496px) {
    width: 100%;
    height: 100%;
  }
`;

const Line = styled.div`
  width: 100%;
  border: 1px solid rgb(211 211 211 / 54%);
  margin-top: 20px;
`;

const AvatarCard = styled.div`
  > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;

    > img {
      width: 120px;
      height: 120px;
      border: 1px solid rgba(211, 211, 211, 1);
    }

    .check {
      position: absolute;
      width: 20px;
      height: 20px;
      top: 5px;
      right: 5px;
      border: 0;
    }

    > p {
      font-size: 12px;
      color: rgba(76, 80, 84, 1);
      font-weight: 700;
      margin-top: 10px;
    }
  }
`;

const CurrentProfile = styled.div`
  > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    > img {
      width: 120px;
      height: 120px;
      border: 1px solid rgba(79, 150, 255, 1);
      background-color: rgba(220, 232, 251, 1);
    }

    > p {
      font-size: 12px;
      color: rgba(76, 80, 84, 1);
      font-weight: 700;
      margin-top: 10px;
    }
  }
`;

const Wrapper = styled.div`
  padding-top: 100px;
  background-color: #f5f5f5;
  width: 100%;
  /* padding-bottom: 150px; */

  > section {
    width: 100%;
    position: relative;
    right: 0;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    z-index: 100;

    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: fixed;
      top: 110px;

      > p {
        color: rgba(114, 114, 114, 1);
        font-weight: 600;
        font-size: 12px;
      }
    }
  }
`;
